import styled from 'styled-components';
import { __ } from '../../i18n/l10n';
import { COLORS } from '../../styles/colors';
import { breakpoint } from '../../styles/constants';
import { splitNumber } from '../../utils/splitNumber';

export interface WxPriceProps {
  price: number;
  priceBefore?: number;
  dark?: boolean;
  background?: boolean;
  noPadding?: boolean;
  style?: React.CSSProperties;
}

const WxPrice = ({
  price,
  priceBefore = -1,
  dark = false,
  background = true,
  noPadding,
  style,
}: WxPriceProps) => {
  return (
    <Container style={style}>
      {priceBefore !== -1 && (
        <CrossedPrice dark={dark}>{`${splitNumber(priceBefore)} ${__(
          'MILES',
        )}`}</CrossedPrice>
      )}
      <Price
        $background={background}
        style={{ padding: noPadding ? 0 : undefined }}
      >{`${splitNumber(price)} ${__('MILES')}`}</Price>
    </Container>
  );
};

const Container = styled.div`
  width: fit-content;
  p {
    font-weight: 900;
  }
`;

const CrossedPrice = styled.p<{ dark: boolean }>`
  color: ${({ dark }) => (dark ? COLORS.white : COLORS.gray)};
  text-decoration-line: line-through;
  margin-right: 0.5rem;
  font-size: 0.625em;
  text-align: right;

  @media (min-width: ${breakpoint}) {
    font-size: 0.75rem;
  }
`;

const Price = styled.p<{ $background: boolean }>`
  color: ${COLORS.white};
  background-color: ${({ $background }) =>
    $background ? COLORS.black : 'transparent'};
  font-size: 0.75rem;
  @media (min-width: ${breakpoint}) {
    font-size: 0.875rem;
  }
  padding: 0.5rem;
  white-space: nowrap;
`;

export default WxPrice;
